
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesGiftVoucherGrid extends Serenity.EntityGrid<ECommSalesGiftVoucherRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesGiftVoucher'; }
        protected getDialogType() { return ECommSalesGiftVoucherDialog; }
        protected getIdProperty() { return ECommSalesGiftVoucherRow.idProperty; }
        protected getInsertPermission() { return ECommSalesGiftVoucherRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesGiftVoucherRow.localTextPrefix; }
        protected getService() { return ECommSalesGiftVoucherService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}